import React,{PureComponent} from 'react';
import {connect} from 'react-redux';

import AuthoriseView from './AuthoriseView';
import {lookUpAuthApp,validateToken} from 'actions/index';

class Authorise extends PureComponent{
    constructor(props){
        super(props);
        this.state={
            query:{},
            loaded:false,
            success:false,
            error:'',
        }
    }
    componentDidMount(){
        const query = this.getQueryStringParams(window.location.search);
        this.setState({query:query,error:this.checkParamsExist(query,['redirect_uri','client_id'])});
        if(query.client_id && query.redirect_uri){
            this.props.lookUpAuthApp(query)
            .then(()=>this.setState({success:true}))
            .catch(err=>{
                this.setState({error:this.props.error});
            })
        }
        if(this.props.authenticated){
            this.props.validateToken();
        }
    }
    checkParamsExist(query,params){
        return params.map(param=>{
            return !query.hasOwnProperty(param.toString()) || query[param].length===0 ? `Missing ${param} in request` : null;
        }).filter(e=>e)[0];
    }
    getQueryStringParams=(query)=>{
        const queryState = query
            ? (/^[?#]/.test(query) ? query.slice(1) : query)
                .split('&')
                .reduce((params, param) => {
                        let [key, value] = param.split('=');
                        params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
                        return params;
                    }, {}
                )
            : {};
        queryState.redirect_uri = queryState.redirect_uri.slice(queryState.redirect_uri.length-1) === '/' ? queryState.redirect_uri.slice(0,queryState.redirect_uri.length-1) : queryState.redirect_uri;
        return queryState;
    };
    render(){
        return <AuthoriseView 
                    error={this.state.error}
                    success={this.state.success}
                    authenticated={this.props.authenticated}
                    user={this.props.user}
                    authApp={this.props.authApp}
                    query={this.state.query}/>
    }
}

function mapStateToProps(state){
    return{
        error:state.authorise.error,
        authenticated:state.auth.authenticated,
        user:state.user,
        authApp:state.authorise.authApp,
    }
}

export default connect(mapStateToProps,{lookUpAuthApp,validateToken})(Authorise);


// WEBPACK FOOTER //
// ./src/scenes/Authorise/index.js